import { useEffect } from 'react';
import { useConsent, CONSENT_TYPES } from '../contexts/ConsentContext';
import { initGA, updateGAConsent, trackPageView } from '../utils/analytics';

export function useAnalytics() {
  const { consent, hasUserInteracted } = useConsent();

  // Initialize Google Analytics
  useEffect(() => {
    initGA();
  }, []);

  // Update consent when user preferences change
  useEffect(() => {
    if (hasUserInteracted) {
      updateGAConsent(consent);
    }
  }, [consent, hasUserInteracted]);

  // Listen for consent updates
  useEffect(() => {
    const handleConsentUpdate = (event) => {
      updateGAConsent(event.detail);
    };

    window.addEventListener('consentUpdated', handleConsentUpdate);
    return () => window.removeEventListener('consentUpdated', handleConsentUpdate);
  }, []);

  // Track page views (only if analytics consent is given)
  const trackPage = (path, title) => {
    if (consent[CONSENT_TYPES.ANALYTICS]) {
      trackPageView(path, title);
    }
  };

  return {
    trackPage,
    hasAnalyticsConsent: consent[CONSENT_TYPES.ANALYTICS],
    hasMarketingConsent: consent[CONSENT_TYPES.MARKETING],
    hasPreferencesConsent: consent[CONSENT_TYPES.PREFERENCES]
  };
}
